import React, {Component} from 'react';
import {
  FullForm
} from "../styled";
import {
  EditImageByVariant
} from "../edit";
import { isVariant } from "../utils";

class  FormImages extends Component{
  constructor(props) {
    super(props);
    this.state = {
      categoryName: "",
      categories: {},
      open: false,
      isVariant: false
    };
    //  console.log(JSON.stringify(props.record));
    
  }
   
  checkVariant = (variant, name) => {
    const check = isVariant(variant, name, this.props.nameProduct);
    if (this.state.isVariant !== check) {
      setTimeout(() => this.setState({ isVariant: check }), 500);
    }
  };
  onUpdatePhotos = photos => {
    this.props.updatePhotos(photos);
  };
  renderImageVariant(variant, nameProduct, tagsProduct, photosProduct) {
    return(
      <FullForm style={{marginTop: 16}}>
        <EditImageByVariant
          variant={variant}
          onUpdatePhotos={this.onUpdatePhotos.bind(this)}
          nameProduct={nameProduct}
          tagsProduct={tagsProduct}
          photos={photosProduct}
        />
      </FullForm>
    )
  }
  render(){
    const {
      nameProduct,
      tagsProduct,
      variant,
      photosProduct
    } = this.props;
    this.checkVariant(variant, nameProduct);
    return(
      <div>
        {this.state.isVariant && this.renderImageVariant(variant, nameProduct, tagsProduct, photosProduct)}
      </div>
    );
  }
}
//
export default FormImages;


// WEBPACK FOOTER //
// ./src/products/form/FormImages.js